// import Core from '../Core/Core';
import { ILogger } from '../Core/Logger';
import getLogger from '../Core/Logger';
import { ISGTrackData, Platform } from './SDK';

const sdkLogger: ILogger = getLogger('[SDK-TRACKING]:');

export interface ISDKtracking {
    gameTracking: (trackData: ISGTrackData) => Promise<any>;
    sendAllWaitingTracks: () => Promise<any>;
    waitingTracks: ISGTrackData[];
    levelStart: (level: number) => Promise<void>;
    levelEnd: (level: number, score: number, state: string) => Promise<void>;
}

export class SDKtracking implements ISDKtracking {
    public platform: any;
    public waitingTracks: ISGTrackData[] = [];

    constructor(platform: any) {
        this.platform = platform;
    }

    public async gameTracking(trackData: ISGTrackData) {
        /* if (!this.checkConnectionFunc()) {
        this.waitingTracks.push(trackData);
        return Promise.resolve('tracking is stored until connection');
    } */
        return await this.platform.gameTracking(trackData);
    }

    public async levelStart(level: number) {
        if (sgPlatform === Platform.Network) {
            return await this.platform.levelStart(level);
        }
    }

    public async levelEnd(level: number, score: number, state: string) {
        if (sgPlatform === Platform.Network) {
            return await this.platform.levelEnd(level, score, state);
        }
    }

    // @ts-ignore
    public async sendAllWaitingTracks() {
        const sends = this.waitingTracks.slice(0);
        const sent: ISGTrackData[] = [];
        for (const item of sends) {
            await this.gameTracking(item)
                .then(() => {
                    sent.push(item);
                })
                .catch(err => {
                    sdkLogger.debug('error sending waiting track: ' + item.dimension1 + ': ' + err);
                });
        }

        this.waitingTracks = sends.filter(i => sent.indexOf(i) === -1);

        return Promise.resolve('waiting tracks sent');
    }
}
